import { render, staticRenderFns } from "./PasswordLoginButton.vue?vue&type=template&id=177f6d6a&scoped=true"
import script from "./PasswordLoginButton.vue?vue&type=script&lang=js"
export * from "./PasswordLoginButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177f6d6a",
  null
  
)

export default component.exports